import { FilterColumnTypes } from "../Utils/Interfaces/IFilter";

export interface HeadCell {
  text: string;
  id: string;
  filter?: boolean;
  filterType?: FilterColumnTypes;
  // converter?: (value: unknown) => unknown; // no need to define this here
}
export const tableSchema: HeadCell[] = [
  {
    text: "Status",
    id: "status-headCell",
    filter: true,
    filterType: FilterColumnTypes.STATUS,
  },
  {
    text: "Unit Number",
    id: "unitNumber-headCell",
  },
  {
    text: "ILU Code",
    id: "iluCode-headCell",
  },
  {
    text: "ADR",
    id: "adr-headCell",
    filter: true,
    filterType: FilterColumnTypes.ADR,
  },
  {
    text: "Vessel",
    id: "vessel-headCell",
    filter: true,
    filterType: FilterColumnTypes.VESSEL,
  },
  {
    text: "Arrival Date",
    id: "arrivalDate-headCell",
  },
  {
    text: "Customer Name",
    id: "customerName-headCell",
    filter: true,
    filterType: FilterColumnTypes.CUSTOMERNAME,
  },
  {
    text: "Customer Note",
    id: "customerNote-headCell",
  },
  {
    text: "POD",
    id: "pod-headCell",
    filter: true,
    filterType: FilterColumnTypes.POD,
  },
  {
    text: "",
    id: "action-headCell",
  },
];
